import './App.css';
import {
    Box, Button,
    Divider,
    Drawer,
    IconButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
    MenuList,
    ThemeProvider,
    Typography
} from "@mui/material";

import AttributionIcon from '@mui/icons-material/Attribution';

import theme from "../theme";
import config from '../config';
import {Helmet} from "react-helmet";
import {Navigate, Route, Routes} from "react-router";
import PublisherCampaigns from "../components/Publisher/Campaign/PublisherCampaigns";
import {NavLink, useLocation, useSearchParams} from "react-router-dom";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import React, {useEffect, useState, useMemo} from "react";
import {styled} from "@mui/system";

import {
    Search as SearchIcon,
    SportsEsports,
    AltRoute,
    FormatListBulleted,
    OtherHouses,
    Rule,
    Group, Schema,
    AttachMoney, CalendarToday
} from '@mui/icons-material';


import Search from "../components/Campaign/Search";
import CampaignType from "../components/AdminPanel/CampaignType/CampaignType";
import Header from "../components/Header";
import FormWrapper, {FORM_TYPES} from "../components/FormWrapper";
import Environment from "../components/AdminPanel/Environment/Environment";
import AudienceParameter from "../components/AdminPanel/AudienceParameter/AudienceParameter";
import UserGroup from "../components/AdminPanel/UserGroup/UserGroup";

import {useDispatch, useSelector} from "react-redux";
import {getEnvName, isNeedToShowMode, isStageAdmin} from "../components/Utils/CommonUtils";

import PublisherABTests from "../components/Publisher/Abtests/PublisherABTests";
import {Alert} from "@mui/lab";

import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import {acquireToken} from "../core/api/authActions";

import PublisherCampaignsTemplates from "../components/Publisher/CampaignTemplates/PublisherCampaignsTemplates";
import LiveOpsVariants from "../components/LiveOpsVariants";
import Logs from "../components/AdminPanel/Logs";
import HistoryIcon from '@mui/icons-material/History';

import DataObjectIcon from '@mui/icons-material/DataObject';
import TimelineCampaignsProvider from "../timeline/TimelineCampaignsProvider";
import Streams from "../components/AdminPanel/Streams/Streams";
import {configs, getDomainAlias} from "../constants";
import {ProfileSearch} from "../components/Profile/ProfileSearch";

const drawerWidth = 260;

// Оставляем DrawerHeader только для создания отступа под фиксированной шапкой
const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));


export default function App({ instance }) {
    const [searchParams] = useSearchParams();
    const [className, setClassName] = useState("")
    const dispatch = useDispatch();

    const sourceMode = useSelector((state) => state.data.SourceMode);
    const userSession = useSelector((state) => state.data.UserSession);

    const appMode = sourceMode.mode;
    const cfg = configs[getDomainAlias()]

    const env1 = getEnvName('env', sourceMode, searchParams)
    const env2 = getEnvName('env2', sourceMode, searchParams)
    const location = useLocation()
    const isIframeMode = location.pathname.includes('/profile_iframe');

    const menu = useMemo(() => [
        {title: 'Main', isDividerAfter: false, isInfoElement: true},
        {
            to: `/publisher/campaigns?env=${env1}&env2=${env2}`,
            path: '/publisher/campaigns',
            title: 'Campaigns',
            element: <PublisherCampaigns/>,
            icon: <SportsEsports size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
        {
            to: `/publisher/abtests?env=${env1}&env2=${env2}`,
            path: '/publisher/abtests',
            title: 'AB Tests',
            element: <PublisherABTests/>,
            icon: <AltRoute size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false,
        },
        {
            to: `/search?env=${env1}`,
            path: 'search',
            title: 'Search',
            element: <Search/>,
            icon: <SearchIcon size={"small"}/>,
            isDividerAfter: true,
            isInfoElement: false
        },

        {
            to: `/publisher/templates?env=${env1}&env2=${env2}`,
            path: '/publisher/templates',
            title: 'Templates',
            element: <PublisherCampaignsTemplates/>,
            icon: <Schema size={"small"}/>,
            isDividerAfter: true,
            isInfoElement: false
        },
        {
            to: `/variants?env=liveops`,
            path: '/variants',
            title: 'LiveOps Variants',
            element: <LiveOpsVariants />,
            disabled: !['cm','local','staging'].includes(getDomainAlias()),
            icon: <AttachMoney size={"small"}/>,
            isDividerAfter: true,
            isInfoElement: false
        },

        {
            to: `/profile/search?env=${env1}`,
            path: 'profile/search',
            title: 'Profile',
            element: <ProfileSearch />,
            icon: <AttributionIcon size={"small"}/>,
            isDividerAfter: true,
            isInfoElement: false
        },

        {title: 'Admin Panel', isDividerAfter: false, isInfoElement: true},
        {
            to: `/campaignType?env=${env1}`,
            path: 'campaignType',
            title: 'Campaign Types',
            element: <CampaignType/>,
            icon: <FormatListBulleted size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
        {
            to: `/environment?env=${env1}`,
            path: 'environment',
            title: 'Environments',
            element: <Environment/>,
            icon: <OtherHouses size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
        {
            to: `/parameter?env=${env1}`,
            path: 'parameter',
            title: 'Audience Requirements',
            element: <AudienceParameter/>,
            icon: <Rule size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
        {
            to: `/userGroup?env=${env1}`,
            path: 'userGroup',
            title: 'User Groups',
            element: <UserGroup/>,
            icon: <Group size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
        // {
        //     to: `/logs?env=${env1}`,
        //     path: 'logs',
        //     title: 'Logs',
        //     element: <Logs />,
        //     icon: <HistoryIcon size={"small"}/>,
        //     isDividerAfter: false,
        //     isInfoElement: false
        // },
        {
            to: `/streams`,
            path: '/streams',
            title: 'Streams',
            element: <Streams/>,
            icon: <CalendarToday size={"small"}/>,
            isDividerAfter: false,
            isInfoElement: false
        },
    ], [env1, env2]);


    useEffect(() => {
        acquireToken(dispatch, instance);
    }, [dispatch, userSession.fetching, instance]);

    useEffect(() => {
        setClassName(env2 || "")
    }, [searchParams, location, env2])

    useEffect(() => {
        const setCurrentPageTitle = () => {
            const currentItem = menu.find(item => location.pathname.includes(item.path));
            if (currentItem && currentItem.title) {
                document.title = currentItem.title + ' | Mephisto ' + cfg.title;
            } else {
                document.title = 'Mephisto ' + cfg.title;
            }
        };
        setCurrentPageTitle();
    }, [location, menu, cfg.title])


    const [state, setState] = useState({
        open: false,
        authenticated: false
    });

    const routesContent = useMemo(() => (
        <Routes>
            {menu.map((object, index) => (
                !object.isInfoElement && <Route key={index} path={object.path} element={object.element}/>
            ))}
            <Route path="/timeline" element={<TimelineCampaignsProvider/>} />
            <Route path="/" element={<PublisherCampaigns />} />
            <Route path='/creator/abtests/:id?' element={<FormWrapper formType={FORM_TYPES.AB_TESTS}/>}/>
            <Route path='/creator/abtestsmini/:id?' element={<FormWrapper formType={FORM_TYPES.AB_TEST_MINI}/>}/>
            <Route path='/creator/templates/:id?' element={<FormWrapper formType={FORM_TYPES.TEMPLATES}/>}/>
            <Route path='/creator/campaigns/:id?' element={<FormWrapper formType={FORM_TYPES.CAMPAIGNS}/>}/>
            <Route path='/profile_iframe' element={<ProfileSearch />}/>
        </Routes>
    ), [menu]);

    const handleDrawerOpen = () => {
        setState(prev => ({ ...prev, open: true }));
    };

    const handleDrawerClose = () => {
        setState(prev => ({ ...prev, open: false }));
    };

    const handleMenuItemClick = () => {
        setState(prev => ({ ...prev, open: false }));
    }

    // Закрытие по клику вне меню (для temporary drawer это не обязательно, т.к. есть Backdrop, но оставим для надежности)
    useEffect(() => {
        const handleClickOutside = (event) => {
            const drawer = document.querySelector('.MuiDrawer-root');
            // Если кликнули мимо Drawer и Drawer открыт
            if (state.open && drawer && !drawer.contains(event.target)) {
                // setState(prev => ({ ...prev, open: false }));
                // Для temporary drawer MUI сам обрабатывает клик по Backdrop (затемнению)
            }
        };
    }, [state.open]);

    const handleLoginPopup = () => {
        instance
            .loginPopup({
                ...{},
                redirectUri: '/dummy.html',
            })
            .catch((error) => console.log(error));
    };

    if(isIframeMode) {
        return <MsalProvider instance={instance}>
            <Box sx={{ p: 0, m: 0, width: '100%', height: '100vh', bgcolor: 'background.default' }}>
                <AuthenticatedTemplate>
                    {/* Рендерим компонент напрямую или через Routes, если нужны параметры URL */}
                    <Routes>
                        <Route path='/profile_iframe' element={<ProfileSearch />}/>
                    </Routes>
                </AuthenticatedTemplate>

                <UnauthenticatedTemplate>
                    {/* Можно показать заглушку или пустой div, если токен еще не получен */}
                    <div style={{ padding: 20 }}>
                        <div>Sign-in to Mephisto to view this content.</div>
                        <Button sx={{mt:2}} id="login-button" variant={"contained"} color="warning" onClick={handleLoginPopup}>
                            Sign in
                        </Button>
                    </div>
                </UnauthenticatedTemplate>
            </Box>
        </MsalProvider>
    }

    return (
        <MsalProvider instance={instance}>
            <ThemeProvider theme={theme}>
                <Helmet {...config.app}></Helmet>

                <Header
                    open={state.open}
                    handleDrawerOpen={handleDrawerOpen}
                />

                <Box sx={{ display: 'flex' }} className={"wrapper" + " " + className}>

                    <Drawer
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: drawerWidth,
                                boxSizing: 'border-box',
                            },
                        }}
                        // ВАЖНО: temporary заставляет меню накладываться сверху, а не сдвигать контент
                        variant="temporary"
                        anchor="left"
                        open={state.open}
                        onClose={handleDrawerClose} // Обязательно для temporary drawer
                        ModalProps={{
                            keepMounted: true, // Лучше производительность на мобильных
                        }}
                    >
                        <DrawerHeader>
                            <Typography className={"menu-title"} variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                Mephisto&nbsp;
                                <small style={{ color: '#e20000' }}>
                                    {cfg.title}
                                </small>
                            </Typography>
                            <IconButton onClick={handleDrawerClose}>
                                <ChevronLeftIcon/>
                            </IconButton>
                        </DrawerHeader>
                        <Divider/>
                        <MenuList>
                            {menu.filter(object => object.disabled !== true).map((object, index) => (
                                !object.isInfoElement ?
                                    <Box key={index}>
                                        <MenuItem
                                            component={NavLink}
                                            to={object.to}
                                            onClick={handleMenuItemClick}
                                            disabled={object.disabled}
                                            style={({ isActive }) => ({
                                                backgroundColor: isActive ? 'rgba(0, 0, 0, 0.08)' : 'transparent'
                                            })}
                                        >
                                            <ListItemIcon>
                                                {object.icon}
                                            </ListItemIcon>
                                            <ListItemText>{object.title}</ListItemText>

                                        </MenuItem>
                                        {object.isDividerAfter && <Divider/>}
                                    </Box> :
                                    <MenuItem
                                        component={Box}
                                        disabled={true}
                                        className={"pending"}
                                        key={object.title + index}
                                    >
                                        <ListItemText>{object.title}</ListItemText>
                                    </MenuItem>
                            ))}

                            <Box>
                                <Divider sx={{pt:1, mb:1}}/>
                                <MenuItem
                                    component="a"
                                    href={cfg.baseUrl.replace('/campaign','')+"/swagger-ui/index.html"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <ListItemIcon><DataObjectIcon /></ListItemIcon>
                                    <ListItemText>Swagger UI</ListItemText>
                                </MenuItem>
                            </Box>
                        </MenuList>
                    </Drawer>

                    {/* Основной контент.
                        Мы убрали Main styled component, так как смещение больше не нужно.
                        Используем просто Box с flexGrow.
                    */}
                    <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: 1 }}>

                        {/* DrawerHeader здесь нужен как "распорка", чтобы контент не уходил под фиксированную шапку */}

                        <AuthenticatedTemplate>
                            {isStageAdmin(userSession) ?
                                routesContent :
                                <Alert severity={"info"}>You are not allowed Stage Mephisto.</Alert>
                            }
                        </AuthenticatedTemplate>

                        <UnauthenticatedTemplate>
                            <Alert severity={"info"}>Sign-in to get access to Mephisto {cfg.title}</Alert>
                        </UnauthenticatedTemplate>
                    </Box>
                </Box>

            </ThemeProvider>
        </MsalProvider>
    )
}